import { ImagesService } from './../../service/images.service';
import { RoiService } from './../../service/roi.service';
import { Component, OnInit, ViewChild, ElementRef, Inject, LOCALE_ID } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Tchekb, HydratedTchek } from '../../model/tchekb.model';
import { TchekService, GetTchekOpts } from '../../service/tchek.service';
import { SubmenuOption } from '../submenu/submenu.component';
import { ReportService } from '../../service/report.service';
import { SearchService } from '../../service/search.service';
import { VehicleSettings, Accessibility } from '../../model/settings.model';
import { ParametersService } from '../../service/parameters.service';
import { DamageService } from '../../service/damage.service';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../service/toast.service';
import { VehicleService } from '../../service/vehicle.service';
import * as moment from 'moment';
import { TchekOldService } from '../../service/tchek-old.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import 'parse';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TraceService } from '../../service/trace.service';

const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-tchek-list',
  templateUrl: './tchek-list.component.html',
  styleUrls: ['./tchek-list.component.less']
})
export class TchekListComponent implements OnInit {
  moment = require('moment/moment');
  tcheks: Array<HydratedTchek>;
  submenuOptions: Array<SubmenuOption>;
  submenuOptions2: Array<SubmenuOption>;
  saveTimers: Array<NodeJS.Timer>;
  saveTimers2: Array<NodeJS.Timer>;
  totalUnread: number;
  loading: boolean;
  vehicleSettings: VehicleSettings;
  accessibility: Accessibility;
  isLocal: boolean
  dashboardSettings: any;
  isSuperAdmin = false;
  canDetection = false
  companyname: string;
  @ViewChild('modalDelete') modalDelete: ElementRef;
  modalDeleteRef: NgbModalRef;

  typeOfTchek = ['tchekBasic',
    'tchekOne',
    'tchekLite',
    'tchek360',
    'tchekApp']
  constructor(private readonly i18n: I18n,
    private modalService: NgbModal,
	private readonly _imageService : ImagesService,
    private _traceService: TraceService,
    private readonly _tchekService: TchekService,
    private readonly _routerService: Router,
    private _location: Location,
    private _tchekOldService: TchekOldService,
    private readonly _searchService: SearchService,
    private readonly _roiService: RoiService,
    private _route: ActivatedRoute,
    private readonly _reportService: ReportService,
    private readonly _parametersService: ParametersService,
    private readonly _damageService: DamageService,
    private readonly _vehicleService: VehicleService,
    private readonly _toastService: ToastService,
    @Inject(LOCALE_ID) private locale: string,
  ) {
    if (parse.User.current())
      this.companyname = parse.User.current().get('companyPtr').get('identifier');

    this.isSuperAdmin = this._parametersService.isSuperAdmin
    this.moment.locale('fr')
    this.isLocal = environment.isLocal
    this.vehicleSettings = this._parametersService.getAll().vehicle;
    this.accessibility = this._parametersService.getAll().accessibility;
    console.log('this._parametersService.getAll().accessibility', this._parametersService.getAll().accessibility);
    if (this._parametersService.getAll().accessibility === undefined)
      this.accessibility = { showIcons: false, useFastTrack: true, fastTrackComp: false, fastTrackZoom: true, showImmatPicture: true, fastTrackL1: true, fastTrackL2: true, fastTrackL3: true }
    if (this.accessibility.showImmatPicture === undefined) this.accessibility.showImmatPicture = true
    this.dashboardSettings = this._parametersService.getAll().style.dashboard;
    this.canDetection = this._parametersService.canDetection;
    // console.log('dove', this.canDetection)
    this.submenuOptions = [
		{
		  labelFr: this.i18n({
			id: 'openPlayer',
			value: "Ouvrir le Player",
			description: "Ouvrir le Player",
			meaning: "tchekList"
		  }),
		  handler: (tchekToRedirect: Tchekb) => {
			if (!this.isSuperAdmin) {
			  if (tchekToRedirect.status === 1)
				tchekToRedirect.status = 2;
			  tchekToRedirect.toSync = true;
			  tchekToRedirect.isNew = false;
			}
			var camera = 1
			var picture = 0
			if (tchekToRedirect.picturesSelected) {
			  if (tchekToRedirect.picturesSelected["thumbnail"]) {
				camera = tchekToRedirect.picturesSelected["thumbnail"].camera
				picture = tchekToRedirect.picturesSelected["thumbnail"].picture
			  }
			}
			this._routerService
			  .navigate(['player', tchekToRedirect.id, camera, picture], { queryParams: { isPercent: false } })
			  .then(success => !success && console.log('Navigation failed'))
			  .catch(e => console.error(e));
		  }
		},
		{
		  labelFr: this.i18n({
			id: 'editRapport',
			value: "Editer un rapport",
			description: "Editer un rapport",
			meaning: "tchekList"
		  }),
		  handler: (tchekToRedirect: Tchekb) => {
			if (!this.isSuperAdmin) {
			  if (tchekToRedirect.status === 1)
				tchekToRedirect.status = 2;
			  tchekToRedirect.toSync = true;
			  tchekToRedirect.isNew = false;
			}
			this._reportService.getByTchek(tchekToRedirect.id)
			  .then(reports => {
				if (reports.length > 0)
				  this._routerService
					.navigate(['report', reports[0].id])
					.then(success => !success && console.log('Navigation failed'))
					.catch(e => console.error(e));
				else
				  this._reportService.create(tchekToRedirect.id)
					.then(report => {
					  this._routerService
						.navigate(['report', report.id])
						.then(success => !success && console.log('Navigation failed'))
						.catch(e => console.error(e));
					});
			  });
		  }
		},
		{
		  labelFr: this.i18n({
			id: 'delete',
			value: "Supprimer",
			description: "Supprimer",
			meaning: "tchekList"
		  }),
		  handler: (tchekToDelete: Tchekb) => {
			this.openModalDelete(tchekToDelete)
		  }
		},
		{
		  labelFr: this.i18n({
			id: 'history',
			value: "Historique",
			description: "Historique",
			meaning: "tchekList"
		  }),
		  handler: (tchekToRedirect: Tchekb) => {
			if (tchekToRedirect.vehiclePtr.immat !== 'NO_IMMAT')
			  this._searchService.vehicleHistoryF(tchekToRedirect.vehiclePtr.immat);
		  }
		}
	  ];

	  this.submenuOptions2 = [
		{
		  labelFr: this.i18n({
			id: 'openPlayer',
			value: "Ouvrir le Player",
			description: "Ouvrir le Player",
			meaning: "tchekList"
		  }),
		  handler: (tchekToRedirect: Tchekb) => {
			if (!this.isSuperAdmin) {
			  if (tchekToRedirect.status === 1)
				tchekToRedirect.status = 2;
			  tchekToRedirect.toSync = true;
			  tchekToRedirect.isNew = false;
			}
			var camera = 1
			var picture = 0
			if (tchekToRedirect.picturesSelected) {
			  if (tchekToRedirect.picturesSelected["thumbnail"]) {
				camera = tchekToRedirect.picturesSelected["thumbnail"].camera
				picture = tchekToRedirect.picturesSelected["thumbnail"].picture
			  }
			}
			this._routerService
			  .navigate(['player', tchekToRedirect.id, camera, picture], { queryParams: { isPercent: false } })
			  .then(success => !success && console.log('Navigation failed'))
			  .catch(e => console.error(e));
		  }
		},
		{
			labelFr: this.i18n({
			  id: 'openReport',
			  value: "Ouvrir Le Rapport",
			  description: "Ouvrir Le Rapport",
			  meaning: "tchekList"
			}),
			handler: async (tchekToRedirect: Tchekb) => {
				const token  = await this._roiService.getToken(tchekToRedirect.getParseInstance());
				window.open(`${environment.frontV3Host}/${this.locale || 'en'}/report?token=${token}`, '_blank').focus();
				}
		  },
		  {
			labelFr: this.i18n({
			  id: 'openReport',
			  value: "Ouvrir Le Rapport Client",
			  description: "Ouvrir Le Rapport Client",
			  meaning: "tchekList"
			}),
			handler: async (tchekToRedirect: Tchekb) => {
			const token  = await this._roiService.getToken(tchekToRedirect.getParseInstance(), false);
			window.open(`${environment.frontV3Host}/${this.locale || 'en'}/report?token=${token}`, '_blank').focus();
			}
		  },
		{
		  labelFr: this.i18n({
			id: 'delete',
			value: "Supprimer",
			description: "Supprimer",
			meaning: "tchekList"
		  }),
		  handler: (tchekToDelete: Tchekb) => {
			this.openModalDelete(tchekToDelete)
		  }
		},
		{
		  labelFr: this.i18n({
			id: 'history',
			value: "Historique",
			description: "Historique",
			meaning: "tchekList"
		  }),
		  handler: (tchekToRedirect: Tchekb) => {
			if (tchekToRedirect.vehiclePtr.immat !== 'NO_IMMAT')
			  this._searchService.vehicleHistoryF(tchekToRedirect.vehiclePtr.immat);
		  }
		}
	  ];

	  
     if (this._parametersService.isSuperAdmin) {
      this.submenuOptions2.splice(1, 0,
        {
          labelFr: this.i18n({
            id: 'reloadReport',
            value: "Relancer détection",
            description: "Relancer détection",
            meaning: "tchekList"
          }),
          handler: (tchek: Tchekb) => {
            tchek.toAnalyze = true
            tchek.detectionFinished = false
            tchek.percentDamage = 0
            tchek.percentParts = "0"
            tchek.toSync = true
            this._tchekService.save(tchek).then(savedTchek => {
              console.log("Relancer detection", tchek.id)
            });
          }
        })
      this.submenuOptions2.splice(2, 0,
        {
          labelFr: this.i18n({
            id: 'notAnalyze',
            value: "Ne pas analyser",
            description: "Ne pas analyser",
            meaning: "tchekList"
          }),
          handler: (tchek: Tchekb) => {
            tchek.toAnalyze = false
            tchek.detectionFinished = true
            tchek.percentDamage = 0
            tchek.percentParts = "0"
            tchek.toSync = true
            this._tchekService.save(tchek).then(savedTchek => {
              console.log("Ne pas analyser", tchek.id)
            });
          }
        })
    }
    this.saveTimers = [];
    this.saveTimers2 = [];
    this.loading = true;
  }

  ngOnInit() {
    if (parse.User.current())
      this.companyname = parse.User.current().get('companyPtr').get('identifier');

    /*  setTimeout(() => {
          $("body #hubspot-messages-iframe-container").css({"display": "none!important"});
      }, 4000);  */
  }

  stopPropa(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleImageError(e: Event) {
    const target = e.target as HTMLImageElement;
    target.src = 'assets/icon/corrupted@2x.png';
	target.style.width = '120px'
    target.classList.add('row-thumbnail-error');
  }

  handleSubmenuSelection(e: any, tchek: Tchekb) {
	  let sub = this.submenuOptions
    console.log("sbe ",this.companyname)
 	  if ([4,5].includes(tchek.type) || (tchek.type === 0 && (this.isSuperAdmin || this.companyname=="BCA_Scan") )) sub = this.submenuOptions2
	  sub[e].handler(tchek);
  }

  reason: string
  async openModalDelete(tchek: Tchekb) {
    this.reason = ''
    this.modalDeleteRef = await this.modalService.open(this.modalDelete, { backdropClass: 'backdropClassModal' });
    document.getElementById('modalInput').focus();
    this.modalDeleteRef.result.then(async (result) => {
      console.log(this.reason);
      this._traceService.saveTrace(tchek.id, `{action : "tchek deleted", reason : "${this.reason}"}`)
      this._tchekService.delete(tchek);
    }, (reason) => {
      console.log('exit', reason);
    });
  }
  saveModal() {
    this.modalDeleteRef.close('Save click')
  }

  handleRowClick(event: Event, tchek: Tchekb) {
    // Check if Tchek has Report, if not create default one
    if (!this.isSuperAdmin && tchek.isNew === true) {
      if (tchek.status === 1)
        tchek.status = 2;
      tchek.isNew = false;
      tchek.toSync = true;
    }
    var camera = 1
    var picture = 0
    if (tchek.picturesSelected) {
      if (tchek.picturesSelected["thumbnail"]) {
        camera = tchek.picturesSelected["thumbnail"].camera
        picture = tchek.picturesSelected["thumbnail"].picture
      }
    }
    console.log('this._parametersService.getAll().accessibility', this._parametersService.getAll().accessibility);

    console.log('use fast track : ', this._parametersService.getAll().accessibility, this.accessibility.useFastTrack);
    if (this.accessibility.useFastTrack !== false && tchek.damageControl === undefined && tchek.numberDamage > 0 && tchek.numberNewDamage > 0) // for testing => &&  environment.isLocal )
      this._routerService
        .navigate(['fasttrack', tchek.id])
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    else
      this._reportService.getByTchek(tchek.id)
        .then(reports => {
          if (reports && reports.length < 1)
            this._reportService.create(tchek.id)
              .then(report => {
                this.opentchek(tchek, camera, picture)
              });
          else
            this.opentchek(tchek, camera, picture)
        });
  }

  cloudFrontImage(tchek : Tchekb) : string{
 	 let  t = this._roiService.tokenMemory.get(tchek.getParseInstance().get('companyPtr').id)
 	if (t === undefined) return 
	let key = t.id
	let name = [key,tchek.id, tchek.thumbnailImagePtr.name].join('/')
	//  console.log(name);
	return this._imageService.cloudfrontUrl(name)
}

  opentchek(tchek, camera, picture) {
     if ([4,5,2].includes(tchek.type))
      this._routerService
        .navigate(['viewer', tchek.id, picture], { queryParams: { isPercent: false } })
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    else {
      this._routerService
        .navigate(['player', tchek.id, camera, picture], { queryParams: { isPercent: false } })
        .then(success => !success && console.log('Navigation failed'))
        .catch(e => console.error(e));
    }
  }

  /** Status Man
   *  unRead = 1 
   *  read = 2
   *  unFlagged = 3
   *  flagged = 4 
   *  unInspected = read
   *  inspected = 5
   */



  handleRequestVideoTchek(event: Event, tchek: Tchekb) {
    if (tchek.scanToUpload !== true) {
      if (tchek.isHDLocal === false) {
        this._toastService.toastOpen(undefined, this.i18n({
          id: "deletedHdScan",
          value: "Les videos hd de ce scan ont été supprimées en local.",
          description: "Les videos hd de ce scan ont été supprimées en local.",
          meaning: "tchekList"
        }), "error");
        this.stopPropa(event);
        return
      }
      this.stopPropa(event);
      tchek.scanToUpload = true;
      tchek.toSync = true
      tchek.isUploaded = false

      this.markDirty(tchek, { scanToUpload: true, toSync: true, isUploaded: false });
    }
  }


  handleRequestHdTchek(event: Event, tchek: Tchekb) {
    this.stopPropa(event);
    if (tchek &&
      (!tchek.uploadHDPictures || (tchek.uploadHDPictures && tchek.videoConverter === 2)))
      if (tchek.isHDLocal === false)
        this._toastService.toastOpen(undefined, this.i18n({
          id: "deletedHdPictures",
          value: "Les images hd de ce scan ont été supprimées en local.",
          description: "Les images hd de ce scan ont été supprimées en local.",
          meaning: "tchekList"
        }), "error");
      else
        this._tchekOldService.setUploadHd(tchek.id).then(newTchek => {
          tchek = newTchek;
        }, error => { });
  }

  handleRequestExtractVideo(event: Event, tchek: Tchekb) {
    this.stopPropa(event);
    if (tchek && tchek.videoConverter !== 2 && tchek.videoConverter !== 1) {
      tchek.videoConverter = 1;
      this.markDirty(tchek, { videoConverter: 1 });
    }
  }


  handleSetAsRead(event: Event, tchek: Tchekb) {
    if (tchek.status === 1)
      tchek.status = 2;
    tchek.toSync = true;
    tchek.isNew = false;
    this.markDirty(tchek, { isNew: false });
    this.stopPropa(event);
  }

  handleSetAsUnread(event: Event, tchek: Tchekb) {
    tchek.status = 1;
    tchek.isNew = true;
    tchek.isFlagged = false;
    tchek.toSync = true;
    this.markDirty(tchek, { isNew: true });
    this.stopPropa(event);
  }


  handleSetKpi(event: Event, tchek: Tchekb, active: boolean) {
    if (tchek.status === 5)
      tchek.status = 2;
    tchek.toSync = true;
    tchek.kpi = active;
    this.markDirty(tchek, { isNew: false });
    this.stopPropa(event);
  }

  handleSetAsUnInspected(event: Event, tchek: Tchekb) {
    if (tchek.status === 5)
      tchek.status = 2;
    tchek.toSync = true;
    tchek.inspected = false;
    this.markDirty(tchek, { isNew: false });
    this.stopPropa(event);
  }

  handleSetAsInspected(event: Event, tchek: Tchekb) {
    //this.handleRequestExtractVideo(event, tchek)
    tchek.status = 5;
    tchek.inspected = true;
    tchek.isNew = false;
    tchek.toSync = true;
    this.markDirty(tchek, { isNew: true });
    this.stopPropa(event);
  }

  handleSetAsFlagged(event: Event, tchek: Tchekb) {
    tchek.status = 4;
    tchek.isNew = false;
    tchek.isFlagged = true;
    tchek.toSync = true;
    this.markDirty(tchek, { isFlagged: true });
    this.stopPropa(event);
  }

  handleSetAsUnflagged(event: Event, tchek: Tchekb) {
    tchek.status = 3;
    tchek.toSync = true;
    tchek.isFlagged = false;
    this.markDirty(tchek, { isFlagged: false });
    this.stopPropa(event);
  }

  saveVehicle(event: string, tchek: Tchekb, type: string) {
    if (type === 'or')
      tchek.vehiclePtr.or = event.toLocaleUpperCase();
    else if (type === 'vin')
      tchek.vehiclePtr.vin = event.toLocaleUpperCase();
    else if (type === 'model')
      tchek.vehiclePtr.model = event;
    else if (type === 'immat')
      tchek.vehiclePtr.immat = event.toLocaleUpperCase();
    else
      return;

    if (this.saveTimers2[tchek.id]) {
      clearTimeout(this.saveTimers2[tchek.id]);
      this.saveTimers2[tchek.id] = undefined;
    }
    this.saveTimers2[tchek.id] = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._vehicleService.saveVehicle(
        tchek.vehiclePtr.id,
        tchek.vehiclePtr.immat,
        tchek.vehiclePtr.brand,
        tchek.vehiclePtr.model,
        tchek.vehiclePtr.or,
        tchek.vehiclePtr.vin,
        tchek.vehiclePtr.class,
        tchek.id)
        .then(() => {
          this.saveTimers2[tchek.id] = undefined;
          this._toastService.toastOpen(false);
        });
    }, 1000);
  }

  markDirty(tchek: Tchekb, fallback: { [key: string]: any }) {
    if (this.saveTimers[tchek.id]) {
      clearTimeout(this.saveTimers[tchek.id]);
      this.saveTimers[tchek.id] = undefined;
    }
    this.saveTimers[tchek.id] = setTimeout(() => {
      this._tchekService.save(tchek).then(savedTchek => {
        if (savedTchek === undefined) {
          // Falling back to original value
          const [key, value] = Object.entries(fallback)[0];
          tchek[key] = value;
        }
      });
      this.saveTimers[tchek.id] = undefined;
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/element/tchek-list/tchek-list.component.ts